$(function () {
    'use strict';
    // hide text menu
    var hideTextMenu = {
        events: function() {
            var that = this;

            $(window).resize(function(){
                that.windowWidth = $(window).width();
                that.maxWidth = that.windowWidth - that.offsetMenu - that.widthUserMenu;
                if(that.widthMenu > that.maxWidth) {
                    $(".base-menu").addClass("base-menu_compact");
                } else {
                    $(".base-menu").removeClass("base-menu_compact");
                }

                // console.log(that.maxWidth, that.widthMenu, that.widthUserMenu)
            }).resize();
        },

        init: function() {
            var that = this;
            that.widthMenu = $(".base-menu").outerWidth();
            that.offsetMenu = 280;
            that.widthUserMenu = $(".navbar-nav.navbar-right").outerWidth() + 40;

            that.events();

            $(".base-menu").addClass("base-menu_init");
        }
    }
    setTimeout(function(){
        hideTextMenu.init();
    }, 100);

    $("[data-toggle=tooltip]").tooltip({
        trigger: "hover",
        html: true
    });


    // toggle sidebar
    var toggleMenu = {
        showMenu: function() {
            $(".sidebar a").tooltip('destroy');
            $(".sidebar").addClass("sidebar_state_open");
            $(".wrap").addClass("wrap_show_sidebar");
            this.stateMenu = "show";

            Cookies.set('stateMenu', 'open', { expires: 7 });
        },

        hideMenu: function() {
            $(".sidebar a").tooltip();
            $(".sidebar").removeClass("sidebar_state_open");
            $(".wrap").removeClass("wrap_show_sidebar");
            this.stateMenu = "close";

            Cookies.set('stateMenu', 'close', { expires: 7 });
        },

        init: function() {
            var that = this;
            that.stateMenu = "close";

            if(Cookies.get('stateMenu') == "open") {
                that.showMenu();
            }

            $(".js-sidebar-show").on("click", function(e) {
                e.preventDefault();

                if(that.stateMenu == "close") {
                    that.showMenu();
                } else {
                    that.hideMenu();
                }
            });

            setInterval(function(){
                $(".sidebar").addClass("js-init-menu");
                $(".wrap").addClass("js-init-menu");
            }, 100);
        }
    }

    if($(".sidebar .nav").length > 0) {
        toggleMenu.init();
    }

    // fix для fixed menu при горизонтальном скроле
    $(window).scroll(function(){
        if($(window).scrollLeft() > 0) {
            $(".sidebar__inner").css('left', - $(window).scrollLeft());
        } else {
            $(".sidebar__inner").css('left', "");
        }
    });
});